import type { RingSizes } from 'content/products/ring/productMap/enums';

// The server->client pack contract. Split rationale: docs/shop-packs-refactor-plan.md §4.

export type PackFrameOption = {
  /** Stable key recorded as the `_blbg_frame` note attribute. */
  key: string;
  label: string;
  previewImg: string;
};

export type PackSizeOption = {
  size: RingSizes;
  /** OPEN = "size not confirmed"; the card adds a sizing kit as a sibling line. */
  isOpenSize: boolean;
};

export type PackColorOption = {
  key: string;
  /** English fallback; the card prefers `ring.productSelection.<key>`. */
  name: string;
  /** Optional so an unmapped colourway degrades to a labelled pill. */
  swatch?: string;
  sizes: PackSizeOption[];
};

export type PackOffer = {
  id: string;
  title: string;
  description: string;
  imgSrc: string;
  tag?: 'new' | 'popular' | 'sold out';
  /** Resolved against this store; the card refuses to add to a cart on another. */
  store: string;
  price: number;
  currencyCode: string;
  ringFamily: 'air' | 'pro';
  colors: PackColorOption[];
  /** Every size across all colours. */
  sizeUnion: PackSizeOption[];
  frames: PackFrameOption[];
  sizingKitVariantId: string | null;
  /** selectionKey() -> bundle variant GID. */
  variants: Record<string, string>;
};

/** Stringifies size, so a numeric/string drift cannot split a table key. */
export const selectionKey = (
  colorKey: string,
  size: string | number,
  frameKey?: string | null,
): string => [colorKey, String(size), frameKey ?? '-'].join('::');

/** Shopify returns full GIDs; some repo accessory maps store bare numeric ids. */
export const normalizeVariantId = (id: string | number): string =>
  String(id).replace(/^gid:\/\/shopify\/ProductVariant\//, '');
